import React from 'react';
import styled from 'styled-components';
import { vw } from 'components/common/Common';

const Grid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${vw(16)};
`;

const BaseCard = styled.div`
  width: 100%;
  height: 100%;
`;

const TextCard = styled(BaseCard)`
  background: #f4f6fc;
  padding: 24px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 12px;
  min-height: 300px;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #050a30;
  line-height: normal;
`;

const Desc = styled.p`
  margin: 0;
  font-size: 16px;
  color: #050a30;
  line-height: 1.3;
`;

const ImgWrap = styled(BaseCard)`
  overflow: hidden;
`;

const ImgCard = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const FeatureGrid = () => {
  return (
    <Grid>
      <TextCard>
        <Title>Door-to-Destination Service</Title>
        <Desc>
          Experience seamless travel with our comprehensive service that manages every detail from
          start to finish. We coordinate luxury ground transportation to ensure a hassle-free
          journey, for a fully integrated, effortless experience.
        </Desc>
      </TextCard>

      <ImgWrap>
        <ImgCard src="/imgs/webp/jetCard/available.webp" alt="private jet terminal" />
      </ImgWrap>

      <TextCard>
        <Title>Call-Out Notice as Low as 24 Hours for Domestic Flights</Title>
        <Desc>
          Need to fly on short notice? Enjoy the convenience of short-notice departures with our
          private jet card program. Book flights with as little as 24 hours' notice for domestic
          flights and travel on your terms, without delays.
        </Desc>
      </TextCard>

      <ImgWrap>
        <ImgCard src="/imgs/webp/jetCard/person.webp" alt="private jet landing on runway" />
      </ImgWrap>

      <TextCard>
        <Title>
          Preferred Network of Certified, Pre-Screened aircraft fleet under Part 135 operation
        </Title>
        <Desc>
          Fly with confidence knowing you’re traveling with the industry’s most reputable Part 135
          operation. Every partner meets rigorous safety and quality standards for a superior
          private jet experience.
        </Desc>
      </TextCard>

      <ImgWrap>
        <ImgCard src="/imgs/webp/jetCard/pet.webp" alt="pet friendly private jet cabin" />
      </ImgWrap>
    </Grid>
  );
};

export default FeatureGrid;
